import {
  AUTHORIZATION_ACTION_ITEMS_KEY,
  AUTHORIZATION_MENU_ITEMS_KEY,
  setBelongingInformation,
} from "@vrf/fr-vrf-auth-core";
import { saveTo } from "@vrf/fr-vrf-core";
import { JSX, useEffect } from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { useBlocker, useLocation, useNavigationType } from "react-router-dom";
import { ApplicationPage } from "../../pages/application-page";
import {
  useGetActionItems,
  useGetMenuItems,
} from "../../services/screen-authorization/ScreenAuthorizationHook";
import { RoleCvrgType } from "../../util/general-code/enums/general-codes";

import { useAppState } from "../../app";
import { ENV } from "@vrf/fr-vrf-core";
import { isGuestUser } from "../../util/auth-util";
import { useCreateUser } from "../../services/user";
import { useUserDetails } from "@vrf/fr-vrf-core-react";
import { fetchAuthenticatedUser } from "../../services/rest-resource-requester";

const AUTHORIZATION_API_ENDPOINT = ENV("REACT_APP_REST_API_HOST");
const ENABLE_DEV_LOGIN = ENV("REACT_APP_ENABLE_DEV_LOGIN") === "true";

/**
 * Screen Authorization Component
 *
 * @param props
 * @returns
 */
export const ScreenAuthorization = (props: {
  children?: JSX.Element;
}): JSX.Element => {
  const navigationType = useNavigationType();
  const location = useLocation();
  // const handleError = useErrorHandler();
  const [appState, setAppState] = useAppState();
  const [authorized, setAuthorized] = useState(false);

  const [authdActionItems, sendGetActionItems] = useGetActionItems();

  const [authdMenuItems, sendGetMenuItems] = useGetMenuItems();

  const [createUserReponse, sendCreateUser] = useCreateUser();
  const { userDetails } = useUserDetails();

  useBlocker((tx) => {
    // Force reload page when location changed
    if (tx.historyAction !== "REPLACE") {
      saveTo("session", AUTHORIZATION_ACTION_ITEMS_KEY, null);
      saveTo("session", AUTHORIZATION_MENU_ITEMS_KEY, null);
    }
    return false;
  });

  useEffect(() => {
    setAppState({ ...appState, isGodMode: false });

    const path = location.pathname;
    const curPage = ApplicationPage.pageByPath(path);
    if (!curPage) {
      setAuthorized(true);
      return;
    }
    setAuthorized(false);
    setBelongingInformation({
      belongTypeCode: RoleCvrgType.JEDI,
      belongCode: "JEDI",
    });

    if (!ENABLE_DEV_LOGIN) {
      fetchAuthenticatedUser();
    }

    sendGetActionItems({
      blngTypeCd: RoleCvrgType.JEDI,
      blngCd: "JEDI",
    });
    sendGetMenuItems({
      blngTypeCd: RoleCvrgType.JEDI,
      blngCd: "JEDI",
    });
  }, [location.pathname, location.search]);

  const onStoreAuthdActionItemsSucceed = async () => {};

  useEffect(() => {
    if (!authdActionItems) return;
    onStoreAuthdActionItemsSucceed();
    setAuthorized(true);
    if (!userDetails) return;
    if (isGuestUser(userDetails)) {
      sendCreateUser({
        userId: userDetails.userId,
        emplyNum: userDetails.userId,
        userName: userDetails.userName || "",
        mlAdrs: userDetails.email || "",
      });
    }
  }, [authdActionItems]);

  const onStoreAuthdMenuItemsSucceed = async () => {};

  useEffect(() => {
    if (!authdMenuItems) return;
    onStoreAuthdMenuItemsSucceed();
  }, [authdMenuItems]);

  return <>{authorized && props.children}</>;
};
